<template>
    <div>
    <v-layout
      row>
        <p class="accessIndex__text--title">Búsqueda de Usuario</p>
    </v-layout>
    <v-layout
      row
      wrap
      style="background-color: #fff; padding: 24px;">
      <v-flex xs12 row>
        <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
          <v-layout
            row
            wrap
            style="background-color: #fff; padding: 0px;">
          <v-flex
            xs6
            style="padding: 8px">
            <v-text-field
              label="Ingrese el rut del usuario:"
              v-model="searching_rut"
              required
              :rules="[rules.required]"
              oninput="this.value = this.value.toUpperCase()"
              >
            </v-text-field>
          </v-flex>
        </v-layout>
        </v-form>
      </v-flex>

      <v-flex xs2 offset-xs10>
        <v-btn
          outline
          color="#000000"
          style="width: 90%"
          @click="getUserData()"
          :disabled="!valid || searching_rut == '' ">Consultar</v-btn>
      </v-flex>
    </v-layout>

    <div v-if="user_finded">
      <v-layout
      row>
        <p class="accessIndex__text--title" >Información Usuario</p>
      </v-layout>
      <v-layout
        row
        wrap
        style="background-color: #fff; padding: 24px;">
        <v-flex xs12 row>
          <v-form onSubmit="return false;" ref="form" v-model="valid" lazy-validation>
            <v-layout
              row
              wrap
              style="background-color: #fff; padding: 0px;">
            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Nombre:"
                v-model="user.user_info_attributes.name"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Apellido:"
                v-model="user.user_info_attributes.last_name"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Rut:"
                v-model="user.rut"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Correo:"
                v-model="user.email"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

            <!-- <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Plan desde:"
                v-model="user.user_info_attributes.plan_from"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex> -->

            <!-- <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Plan hasta:"
                v-model="user.user_info_attributes.plan_until"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex> -->
<!--
            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Tipo de membresía:"
                v-model="user.user_info_attributes.membership_type"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex> -->

            <!-- <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Tipo de plan:"
                v-model="user.user_info_attributes.plan_type"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex> -->

            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Tipo de usuario:"
                v-model="user.user_info_type"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

            <v-flex
              xs6
              style="padding: 8px">
              <v-text-field
                label="Estado:"
                v-model="user.user_info_attributes.access_state"
                :readonly="true"
                required>
              </v-text-field>
            </v-flex>

          </v-layout>
          </v-form>
        </v-flex>

        <v-flex xs2 offset-xs10>
          <v-btn
            type="button"
            class="time_select_button"
            outline
            color="#000000"
            @click="sendBookingRequest()"
            :disabled="user.user_info_attributes.access_state != 'Activo'">Crear Reserva</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            searching_rut: '',
            user: {
                email: '',
                rut: '',
                user_info_type: '',
                user_info_attributes:{
                    name: "",
                    last_name: "",
                   // plan_from: "",
                   // plan_until: "",
                   // plan_type: "",
                    //membership_type: "",
                    access_state: ""
                }
            },
            rules: {
                required: value => !!value || 'Required.'
            },
            user_finded: false,
            valid: false,
            booking: {
              sublocation_id: "",
              weekday: "",
              start_time: "",
              end_time: "",
              day_schedule: null,
              local_time: ""
            },
            user_rut: "",
            location_time_zone: "",
        }
    },
    mounted() {
      this.booking.sublocation_id = this.getSublocationId()
      this.booking.weekday = this.$route.params.weekday
      this.booking.start_time = this.$route.params.start_time
      this.booking.end_time = this.$route.params.end_time
      this.booking.day_schedule = this.$route.params.day_schedule
      this.booking.local_time = this.$route.params.local_time
      this.location_time_zone = this.$route.params.location_time_zone
      console.log("MOUNTED ", this.booking)
    },
    methods:{
      getUserData(){
        var params = this.$route.params;
        try {
          this.$http.get('app/users/find_user_by_rut', {
              headers: {
                  "X-Device-ID" : this.getDeviceId(),
                  "Authorization" : 'Bearer ' + this.getUserToken()
              },
              params:{
                  rut: this.searching_rut
              }
          }).then(function(response){
            if(response.body != null){
                var data = response.body
                this.user.user_info_attributes.name = data.user_info.name
                this.user.user_info_attributes.last_name = data.user_info.last_name
                this.user.rut = data.rut
                this.user.email = data.email
               // this.user.user_info_attributes.plan_from = data.user_info.plan_from
                //this.user.user_info_attributes.plan_until = data.user_info.plan_until
               // this.user.user_info_attributes.plan_type = data.user_info.plan_type
                //this.user.user_info_attributes.membership_type = data.user_info.membership_type
                this.user.user_info_attributes.access_state = data.user_info.access_state == "GRANTED" ? "Activo" : "Inactivo"
                this.user.user_info_type = data.user_info_type
                this.user_finded = true
            }else{
                this.user_finded = false
                this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
                this.updateIsInAlert(true);
            }
          }, function(response){
            // this.updateAlertMessage("No te hemos encontrado en los registros de sportlife", "Lo sentimos")
            this.user.user_info_attributes.name = ''
            this.user.user_info_attributes.last_name = ''
            this.user.rut = ''
            this.user.email = ''
           // this.user.user_info_attributes.plan_from = ''
           // this.user.user_info_attributes.plan_until = ''
           // this.user.user_info_attributes.plan_type = ''
           // this.user.user_info_attributes.membership_type = ''
            this.user.user_info_attributes.access_state = ''
            this.user.user_info_type = ''
            this.user_finded = false
            this.updateAlertMessage('No se ha encontrado el usuario con el rut ingresado')
            this.updateIsInAlert(true);
          })
        } catch (e) {
            this.updateAlertMessage(e.message)
            this.updateIsInAlert(true);
        }
      },
      sendBookingRequest() {
        var vm = this;
        var myData = { attributes: this.booking, user_id: {rut: this.searching_rut} };
        console.log('MY DATA ', myData)
        console.log('MY DATA ',myData.toString())

        try {
          vm.$http
            .post("app/bookings/counter_booking_create", {
              headers: {
                "X-Device-ID": this.getDeviceId(),
                Authorization: "Bearer " + this.getUserToken()
              },
              data: vm.encrypt(myData).toString()
            })
            .then(
              function(response) {
                if (response.body.meta != undefined && response.body.meta != null) {
                  if (response.body.meta.authentication_token != undefined &&
                    response.body.meta.authentication_token != null) {
                    this.checkToken(response.body.meta.authentication_token);
                  }
                }
                if (response.body && response.status == 201) {
                  this.updateAlertMessage("Reserva creada con éxito");
                  this.updateIsInAlert(true);
                  if(this.getUserType()==='Admin'){
                    vm.$router.push({name: 'access'})
                  }else if(this.getUserType()==='Counter'){
                    vm.$router.push({
                      name: "location_access",
                      params: {
                        id: vm.counter_location_id,
                        filter: false,
                        date: new Date().toISOString().substr(0, 10),
                        date2: new Date().toISOString().substr(0, 10),
                        namex: vm.counter_location_name
                      }
                    });
                  }
                }
              },
              function(response) {
                if (
                  response.body.meta != undefined &&
                  response.body.meta != null
                ) {
                  if (
                    response.body.meta.authentication_token != undefined &&
                    response.body.meta.authentication_token != null
                  ) {
                    this.checkToken(response.body.meta.authentication_token);
                  }
                }
                if (response.status === 402) {
                  console.log("===NewBooking=== 402 ===", response);
                  this.updateAlertMessage(
                    response.body.ans
                  );
                  this.updateIsInAlert(true);
                }
                console.log("Respuesta error de reservas");
                if (response.status == 401) {
                  // this.updateAlertMessage(response.body.errors[0].details, "Un momento...");
                  this.updateAlertMessage("Debes volver a loguearte");
                  this.updateIsInAlert(true);
                } else {
                  try {
                    this.updateAlertMessage(response.body.errors[0].details);
                    this.updateIsInAlert(true);
                  } catch (error) {
                    console.log("Error NewBooking ", error);
                  }
                }
              }
            );
        } catch (e) {
          console.log("Fallo reservas creación");
          this.updateAlertMessage(e.message);
          this.updateIsInAlert(true);
        }
        vm.is_changed = false;
      },


    }, /* closed methods */
}
</script>



// WEBPACK FOOTER //
// src/components/views/locations/sublocations/bookings/UserSelectBooking.vue